import { render } from "./SubscriptionSettings.vue?vue&type=template&id=5089ea8e"
import script from "./SubscriptionSettings.vue?vue&type=script&lang=js"
export * from "./SubscriptionSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__